// extracted by mini-css-extract-plugin
export default {"content":"NotFound_content__1b9bZ","code":"NotFound_code__DuEYU","homeLink":"NotFound_homeLink__UwAQ+"};